<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSort_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12 14.355a.84.84 0 0 1 0-1.196.86.86 0 0 1 1.208 0l2.757 2.73V6.025c0-.474.387-.857.865-.858.478 0 .866.384.866.858v9.952l2.846-2.818a.86.86 0 0 1 1.208 0 .84.84 0 0 1 0 1.196l-4.271 4.23a.86.86 0 0 1-1.207 0zM2.25 10.841a.84.84 0 0 1 0-1.196l4.271-4.23a.86.86 0 0 1 1.208 0L12 9.644a.84.84 0 0 1 0 1.196.86.86 0 0 1-1.208 0l-2.757-2.73v9.865a.86.86 0 0 1-.865.857.86.86 0 0 1-.865-.857V8.023L3.458 10.84a.86.86 0 0 1-1.208 0"
    />
</svg>
